import React, { Component } from "react";
import { Button } from "reactstrap";

class TableComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      pageSize: 10,
    };
  }

  // Handle Page Change
  handlePageChange = (newPage) => {
    this.setState({ currentPage: newPage });
  };

  render() {
    const { data, columns, selectedRows, onRowSelect } = this.props;
    const { currentPage, pageSize } = this.state;

    // Paginate Data
    const startIndex = (currentPage - 1) * pageSize;
    const paginatedData = data.slice(startIndex, startIndex + pageSize);
    const totalPages = Math.ceil(data.length / pageSize);

    return (
      <div className="table-responsive">
        <table className="table table-bordered">
          <thead>
            <tr>
              <th>
                <input
                  type="checkbox"
                  checked={selectedRows.length === data.length && data.length > 0}
                  onChange={() => onRowSelect("all")}
                />
              </th>
              {columns.map((col) => (
                <th key={col.key}>{col.label}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {paginatedData.length > 0 ? (
              paginatedData.map((row) => (
                <tr key={row.id}>
                  <td>
                    <input
                      type="checkbox"
                      checked={selectedRows.includes(row.Id)}
                      onChange={() => onRowSelect(row.Id)}
                    />
                  </td>
                  {columns.map((col) => (
                    <td key={col.key}>
                      {col.label === "Open" ? (
                        <Button color="primary" onClick={()=>this.props.btnOpen_onClick(row)}>
                          Open
                        </Button>
                      ) : (
                        row[col.key]
                      )}
                    </td>
                  ))}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={columns.length + 1} className="text-center">
                  No records found
                </td>
              </tr>
            )}
          </tbody>
        </table>

        {/* Pagination */}
        <div className="d-flex justify-content-between">
          <button
            disabled={currentPage === 1}
            onClick={() => this.handlePageChange(currentPage - 1)}
          >
            Previous
          </button>
          <span>
            Page {currentPage} of {totalPages}
          </span>
          <button
            disabled={currentPage === totalPages}
            onClick={() => this.handlePageChange(currentPage + 1)}
          >
            Next
          </button>
        </div>
      </div>
    );
  }
}

export default TableComponent;
